
  $(document).ready(function() {
    $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
      var currentUrl = window.location.href;
      if(currentUrl.includes('/cart')) {
        if ($('#agree-2').is(':checked')) {
          $(this).submit();
        }
        else {
          // alert("You must agree with the terms and conditions of sales to check out.");
          document.getElementById('terms-error-2').style.display = 'block';
          return false;
        }
      }else {
        if ($('#agree').is(':checked')) {
          $(this).submit();
        }else {
          // alert("You must agree with the terms and conditions of sales to check out.");
          document.getElementById('terms-error').style.display = 'block';
          return false;
        }
      }
     
    });
  });

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class LinkArea extends HTMLElement {
  constructor() {
    super();

    let down, up, link = this.querySelector('a');

    this.down = down;
    this.up = up;
    this.link = link;
    this.url =  this.link.getAttribute('href');
    this.addEventListener('mousedown', this.onMouseDown.bind(this));
    this.addEventListener('mouseup', this.onMouseUp.bind(this));
  }

  onMouseDown() {
    this.down = +new Date();
  }

  onMouseUp() {
    this.up = +new Date();
    if ((this.up - this.down) < 200) {
      this.link.click();
    }
  }
}

customElements.define('link-area', LinkArea);




class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();


  }
  waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}
  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
    // this.mobileSlideShow();
  }




  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

var isAvailable = true
var testu
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.renderProductInfo();
    this.updateMedia();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateVariantInput();
      this.updateURL();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const activeElementId = document.activeElement.id;
    if (!this.currentVariant){
      isAvailable = false
      this.variantData.forEach((variant)=>{
        if (variant.option1 == this.options[0]){
          this.currentVariant = {"id": variant.id, "featured_media": variant.featured_media, "available": false}
        }
      })
      }

    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        testu = html
        if (!isAvailable){
          html.querySelector(".select__select[name='options[size]']").forEach((elem)=>{
            if(elem.value == this.options[1]){
              elem.setAttribute("selected", "selected")
            }else{
              elem.removeAttribute("selected")
            }
        })
        }
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const variantPickerDestination = document.getElementById(`variant-radios-${this.dataset.section}`) || document.getElementById(`variant-selects-${this.dataset.section}`);
        const variantPickerSource = html.getElementById(`variant-radios-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`) || html.getElementById(`variant-selects-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (variantPickerSource && variantPickerDestination) variantPickerDestination.innerHTML = variantPickerSource.innerHTML;

        if (this.is_dynamic_images){
          const mediaGalleryDestination = document.getElementById(`MediaGallery-${this.dataset.section}`)
          const mediaGallerySource = html.getElementById(`MediaGallery-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

          if (mediaGallerySource && mediaGalleryDestination){
            mediaGalleryDestination.remove()
            document.querySelector(".grid__item.product__media-wrapper").append(mediaGallerySource);
          }
        }


        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        document.querySelector('variant-radios') ? this.querySelector(`[for="${activeElementId}"]`).focus() : document.querySelector(`#${activeElementId}`).focus();
        if (!isAvailable){
          this.currentVariant = undefined
        }
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    this.is_dynamic_images = this.is_dynamic_images || JSON.parse(this.querySelector('#dynamic-gallery-meta').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ColorSwatches extends HTMLElement {
  constructor() {
    super();
    this.formLabel = this.querySelector('.form__label');
    this.formLabelTextContent = this.formLabel.textContent;
    const checkedInput = this.querySelector('input:checked');
    if (checkedInput) {
      this.formLabel.textContent = this.formLabelTextContent + ': ' + checkedInput.value;
    }
    this.addEventListener('change', this.onVariantChange);
    this.addEventListener('click', this.onSwatchClick);
    this.addEventListener('mouseover', this.onSwatchHover);
    this.addEventListener('touchstart', this.onSwatchHover, { passive: true });
  }

  onSwatchClick(e) {
    // Check if clicked element is a related product swatch
    const label = e.target.closest('label');
    if (label && label.classList.contains('related-product-swatch-label')) {
      const productUrl = label.dataset.productUrl;
      if (productUrl) {
        e.preventDefault();
        e.stopPropagation();
        // Redirect to related product URL
        window.location.href = productUrl;
        return;
      }
    }
    
    // Check if clicked element is a related product input
    const input = e.target.closest('input.related-product-swatch');
    if (input && input.dataset.productUrl) {
      e.preventDefault();
      e.stopPropagation();
      // Redirect to related product URL
      window.location.href = input.dataset.productUrl;
      return;
    }
  }

  onSwatchHover(e) {
    // Warm up the related product's page in the background so the click feels instant.
    // Does not affect this page's own load - only fires after user interaction.
    const label = e.target.closest('label.related-product-swatch-label');
    if (!label) return;
    const productUrl = label.dataset.productUrl;
    if (!productUrl) return;
    window.KedsSwatchPrefetched = window.KedsSwatchPrefetched || new Set();
    if (window.KedsSwatchPrefetched.has(productUrl)) return;
    window.KedsSwatchPrefetched.add(productUrl);
    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = productUrl;
    document.head.appendChild(link);
  }

  onVariantChange(e) {
    // Check if this is a related product swatch - if so, redirect instead of updating
    if (e.target.classList.contains('related-product-swatch') && e.target.dataset.productUrl) {
      e.preventDefault();
      e.stopPropagation();
      window.location.href = e.target.dataset.productUrl;
      return;
    }

    const target = document.getElementById(e.target.dataset.targetId);
    if (target) {
      target.value = e.target.value;

      const changeEvent = new Event('change', {'bubbles': true, 'cancelable': false});
      target.dispatchEvent(changeEvent);

      this.formLabel.textContent = this.formLabelTextContent + ': ' + e.target.value;
    }
  }
}

customElements.define('color-swatches', ColorSwatches);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class SwatchPicker extends HTMLElement {
  constructor() {
    super();
    this.onElemResize()
    new ResizeObserver(() => this.onElemResize()).observe(this);
  }

  onElemResize() {
    if (this.offsetHeight < this.scrollHeight) {
      let moreSwatchesElem = this.querySelector(".more-swatches")
      if (moreSwatchesElem) {
        moreSwatchesElem.remove()
      }
      let firstRowCount = parseInt((this.offsetWidth / 32))
      let unseenChildrenCount = this.childElementCount - firstRowCount + 2

      moreSwatchesElem = document.createElement('span')
      moreSwatchesElem.classList.add("spf-product__swatch")
      moreSwatchesElem.classList.add("more-swatches")
      moreSwatchesElem.innerHTML = `<span translatable="" class="spf-product__swatch-inner">
      <svg class="spf-product__swatch-image" width="24" height="24"> <image xlink:href="https://cdn.shopify.com/s/files/1/0651/1752/0106/files/color-circle.svg" width="24" height="24"/> </svg>
      <span class="${(unseenChildrenCount > 9) ? 'double' : 'single'}">${unseenChildrenCount}</span>
      <svg xmlns="http://www.w3.org/2000/svg" class="svg-plus-icon" style="width: 1em; height: 1em;vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1"><path d="M544 464V160h-80v304H160v80h304v304h80V544h304v-80z" fill="#565D64"/></svg>`
      this.insertBefore(moreSwatchesElem, this.children[firstRowCount - 2])
      this.querySelector(".more-swatches").onclick = () => {
        this.style.maxHeight = '200px'
      }

    } else if (this.querySelector(".more-swatches")) {
      this.querySelector(".more-swatches").remove()
    }

  }
}

customElements.define('swatch-picker', SwatchPicker);

class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.productMedia = this.querySelector('.card__media img:first-of-type')
    this.variantList = this.querySelector('.card__variant-list')
    this.variantListItems = this.querySelectorAll('.card__variant-list-item')
    // Get current product ID from variant list or first swatch
    this.currentProductId = this.variantList?.dataset.productId || 
                            this.variantListItems[0]?.dataset.productId || 
                            null;
    
    // Bind the method to preserve 'this' context
    this.linkToItem = this.linkToItem.bind(this);
    
    // Attach event listeners to swatch items
    this.variantListItems.forEach(item => {
      item.addEventListener('click', this.linkToItem);
    });

    if (this.variantList) {
      this.onElemResize()
      new ResizeObserver(() => this.onElemResize()).observe(this.variantList);
    }
  }

  onElemResize() {
    const maybeShowMoreEl = this.querySelector('.card__variant-list-show-more-toggle')
    if (this.variantList.offsetHeight < this.variantList.scrollHeight) {
      const { gridTemplateColumns, gridTemplateRows, columnGap } = getComputedStyle(this.variantList)
      const columns = gridTemplateColumns.split(' ').length
      const rows = gridTemplateRows.split(' ').length

      const itemCount = this.variantList.children.length
      const hiddenItemCount = itemCount - columns + 1

      if (maybeShowMoreEl) {
        maybeShowMoreEl.querySelector('span').textContent = '+' + hiddenItemCount
      } else {
        const showMoreEl = document.createElement('li');
        showMoreEl.classList.add('grid-1x1', 'card__variant-list-show-more-toggle')
        showMoreEl.innerHTML = `<span>+${hiddenItemCount}</span>`

        showMoreEl.addEventListener('click', (event) => {
          this.variantList.style.maxHeight = this.variantList.clientHeight + 'px'

          window.requestAnimationFrame(() => {
            this.variantList.style.maxHeight = `calc((${this.variantList.style.maxHeight} * ${rows}) + (${columnGap} * ${rows - 1}))`
            this.variantList.classList.remove('card__variant-list--show-more')
            this.variantList.classList.add('card__variant-list--show-all')
            showMoreEl.remove()
          })
        })

        this.variantList.append(showMoreEl)
      }
    } else {
      maybeShowMoreEl?.remove()
    }
  }

  async linkToItem(event) {
    event.preventDefault();
    event.stopPropagation();

    // Handle clicks on child elements (like <a> or <img>)
    const item = event.target.closest('.card__variant-list-item') || event.currentTarget;
    if (!item) return;
    const clickedProductId = item.dataset.productId;
    const clickedProductUrl = item.dataset.productUrl;
    const clickedVariantId = item.dataset.variantId;
    
    // Ensure we have product IDs as strings for comparison
    let currentProductIdStr = String(this.currentProductId || '');
    const clickedProductIdStr = String(clickedProductId || '');
    
    // If currentProductId is not set, initialize it from the clicked swatch
    if (!currentProductIdStr && clickedProductIdStr) {
      this.currentProductId = clickedProductIdStr;
      currentProductIdStr = clickedProductIdStr;
    }
    
    // Check if this is a different product (related product)
    if (clickedProductIdStr && 
        currentProductIdStr && 
        clickedProductIdStr !== currentProductIdStr && 
        clickedProductUrl &&
        clickedVariantId) {
      // This is a related product - fetch and update entire card
      await this.updateCardFromRelatedProduct(clickedProductUrl, clickedVariantId, item);
      return;
    }

    // Same product - just update variant image (existing behavior)
    this.variantListItems.forEach(item => item.classList.remove('card__variant-list-item--selected'))
    item.classList.add('card__variant-list-item--selected')

    if (!item.dataset.src) {
      console.warn('No data-src found on swatch item');
      return;
    }

    if (!this.productMedia) {
      console.warn('Product media image not found');
      return;
    }

    // Get variant image URL
    let variantImageUrl = item.dataset.src;
    if (!variantImageUrl.startsWith('http')) {
      variantImageUrl = 'https:' + variantImageUrl;
    }

    // Build srcset from variant image URL
    const baseImageUrl = variantImageUrl.split('?')[0]; // Remove query params for base
    const srcsetParts = [
      `${baseImageUrl}?width=165 165w`,
      `${baseImageUrl}?width=360 360w`,
      `${baseImageUrl}?width=533 533w`,
      `${baseImageUrl}?width=720 720w`,
      `${baseImageUrl}?width=940 940w`,
      `${baseImageUrl}?width=1066 1066w`
    ];

    // Update image directly
    this.productMedia.src = `${baseImageUrl}?width=533`;
    this.productMedia.srcset = srcsetParts.join(', ');
    this.productMedia.setAttribute('src', `${baseImageUrl}?width=533`);
    this.productMedia.setAttribute('srcset', srcsetParts.join(', '));
    
    // Force image reload if load() method exists (for HTMLImageElement)
    if (this.productMedia instanceof HTMLImageElement && typeof this.productMedia.load === 'function') {
      this.productMedia.load();
    }

    // Update secondary/hover image if it exists
    const secondaryImage = this.productMedia?.nextElementSibling;
    if (secondaryImage && secondaryImage.tagName === 'IMG') {
      // For same product variants, fetch product data to get the correct second image
      const itemUrl = item.querySelector('a')?.getAttribute('href') || clickedProductUrl;
      if (itemUrl) {
        // Extract product handle from URL
        const productHandle = itemUrl.split('/products/')[1]?.split('?')[0];
        if (productHandle) {
          // Fetch product JSON to get all images
          fetch(`/products/${productHandle}.js`)
            .then(response => response.json())
            .then(productData => {
              // Find the variant to get its associated images
              const variantId = clickedVariantId || item.dataset.variantId;
              const variant = productData.variants?.find(v => v.id.toString() === variantId);
              
              if (variant && productData.images && productData.images.length > 0) {
                // Get images associated with this variant
                let secondImageUrl = null;
                
                // Try to find the second image (index 1) or another image associated with the variant
                if (productData.images.length > 1) {
                  const secondImage = productData.images[1];
                  if (secondImage) {
                    secondImageUrl = secondImage.src || secondImage.url || (typeof secondImage === 'string' ? secondImage : null);
                  }
                }
                
                if (secondImageUrl && typeof secondImageUrl === 'string') {
                  // Ensure URL is complete
                  if (!secondImageUrl.startsWith('http')) {
                    secondImageUrl = 'https:' + secondImageUrl;
                  }
                  
                  // Build srcset for secondary image
                  const baseSecondImageUrl = secondImageUrl.split('?')[0];
                  const secondImageSrcset = `${baseSecondImageUrl}?width=165 165w, ${baseSecondImageUrl}?width=360 360w, ${baseSecondImageUrl}?width=533 533w, ${baseSecondImageUrl}?width=720 720w, ${baseSecondImageUrl}?width=940 940w, ${baseSecondImageUrl}?width=1066 1066w`;
                  
                  // Update secondary image
                  secondaryImage.src = `${baseSecondImageUrl}?width=533`;
                  secondaryImage.srcset = secondImageSrcset;
                  secondaryImage.setAttribute('src', `${baseSecondImageUrl}?width=533`);
                  secondaryImage.setAttribute('srcset', secondImageSrcset);
                } else {
                  // If no second image, remove the secondary image element
                  secondaryImage.remove();
                }
              } else {
                // If we can't find the variant or images, remove secondary image
                secondaryImage.remove();
              }
            })
            .catch(error => {
              console.warn('Could not fetch product data for secondary image:', error);
              // Remove secondary image on error
              secondaryImage.remove();
            });
        } else {
          secondaryImage.remove();
        }
      } else {
        secondaryImage.remove();
      }
    }

    // Update product links
    const itemUrl = item.querySelector('a')?.getAttribute('href') || clickedProductUrl;
    if (itemUrl) {
      this.querySelectorAll('.card__main-link').forEach(link => { 
        link.setAttribute('href', itemUrl);
      })
      this.url = itemUrl
    }
  }

  async updateCardFromRelatedProduct(productUrl, variantId, clickedItem) {
    // Add loading state
    this.classList.add('is-loading');
    
    // Hide add-to-cart button during loading
    const addToCartButtons = this.querySelectorAll('button[type="submit"], .add-to-cart-button, .quick-add-icon__button');
    addToCartButtons.forEach(button => {
      button.style.display = 'none';
    });

    try {
      // Extract product handle from URL
      const productHandle = productUrl.split('/products/')[1]?.split('?')[0];
      if (!productHandle) {
        console.error('Could not extract product handle from URL');
        return;
      }

      // Fetch product JSON data
      const jsonUrl = `/products/${productHandle}.js`;
      const response = await fetch(jsonUrl);
      const productData = await response.json();

      // Find the specific variant
      const variant = productData.variants.find(v => v.id.toString() === variantId);
      if (!variant) {
        console.error('Variant not found:', variantId);
        return;
      }

      // Update the product card ID
      this.currentProductId = productData.id;
      if (this.variantList) {
        this.variantList.dataset.productId = productData.id;
        this.variantList.dataset.productTitle = productData.title;
      }

      // Update product links
      this.querySelectorAll('.card__main-link, a[href*="/products/"]').forEach(link => {
        if (link.closest('.card__variant-list')) return; // Don't update swatch links
        link.setAttribute('href', productUrl);
      });

      // Update product title
      const productTitle = this.querySelector('.card__heading');
      if (productTitle) {
        const titleLink = productTitle.querySelector('a');
        if (titleLink) {
          titleLink.textContent = productData.title;
          titleLink.setAttribute('href', productUrl);
        }
      }

      // Update price - use variant price directly from JSON
      const priceContainer = this.querySelector('.price');
      if (priceContainer && variant) {
        // Format money - use simple formatting for now
        const formatMoney = (cents) => {
          // Convert cents to currency format
          const amount = (cents / 100).toFixed(2);
          // Use Israeli Shekel format
          return `₪ ${amount}`;
        };

        const priceRegularEl = priceContainer.querySelector('.price__regular .price-item--regular');
        const priceSaleEl = priceContainer.querySelector('.price__sale .price-item--sale');
        const priceCompareEl = priceContainer.querySelector('.price__sale .price-item--regular s');
        
        // Check if variant is on sale
        const isOnSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        
        if (isOnSale) {
          // Update sale price
          if (priceSaleEl) {
            priceSaleEl.textContent = formatMoney(variant.price);
          }
          // Update compare at price (strikethrough)
          if (priceCompareEl) {
            priceCompareEl.textContent = formatMoney(variant.compare_at_price);
          }
          // Update regular price container (shows sale price)
          if (priceRegularEl) {
            priceRegularEl.textContent = formatMoney(variant.price);
          }
          priceContainer.classList.add('price--on-sale');
          priceContainer.classList.remove('price--sold-out');
        } else {
          // Regular price
          const formattedPrice = formatMoney(variant.price);
          if (priceRegularEl) {
            priceRegularEl.textContent = formattedPrice;
          }
          priceContainer.classList.remove('price--on-sale');
        }
        
        // Update sold out state
        if (!variant.available) {
          priceContainer.classList.add('price--sold-out');
        } else {
          priceContainer.classList.remove('price--sold-out');
        }
      }

      // Update images - find variant image by image_id
      // Re-select the media container to ensure we have the right elements
      const mediaContainer = this.querySelector('.card__media .media');
      const mainImage = mediaContainer ? mediaContainer.querySelector('img:first-of-type') : null;
      const secondaryImage = mediaContainer ? mediaContainer.querySelector('img:nth-of-type(2)') : null;
      
      let variantImageUrl = null;
      
      // First try: Find image by variant.image_id in productData.images array
      if (variant.image_id && productData.images && productData.images.length > 0) {
        const variantImage = productData.images.find(img => {
          // Match by image ID
          return img.id === variant.image_id || img.id === parseInt(variant.image_id);
        });
        if (variantImage) {
          // Extract URL from image object
          variantImageUrl = variantImage.src || variantImage.url || (typeof variantImage === 'string' ? variantImage : null);
        }
      }
      
      // Second try: variant.featured_image (if available)
      if (!variantImageUrl && variant.featured_image) {
        variantImageUrl = typeof variant.featured_image === 'string' ? variant.featured_image : (variant.featured_image?.src || variant.featured_image?.url);
      }
      
      // Third try: variant.image (if available)
      if (!variantImageUrl && variant.image) {
        variantImageUrl = typeof variant.image === 'string' ? variant.image : (variant.image?.src || variant.image?.url);
      }
      
      // Fourth try: product featured image
      if (!variantImageUrl && productData.featured_image) {
        variantImageUrl = typeof productData.featured_image === 'string' ? productData.featured_image : (productData.featured_image?.src || productData.featured_image?.url);
      }
      
      // Last fallback: first product image
      if (!variantImageUrl && productData.images && productData.images.length > 0) {
        const firstImage = productData.images[0];
        variantImageUrl = firstImage.src || firstImage.url || (typeof firstImage === 'string' ? firstImage : null);
      }
      
      if (variantImageUrl && mainImage) {
        // Ensure variantImageUrl is a string
        if (typeof variantImageUrl !== 'string') {
          console.error('variantImageUrl is not a string:', variantImageUrl);
          // Try to extract URL from object if it's an image object
          if (variantImageUrl && typeof variantImageUrl === 'object') {
            variantImageUrl = variantImageUrl.src || variantImageUrl.url || null;
          } else {
            variantImageUrl = null;
          }
        }
        
        if (variantImageUrl && typeof variantImageUrl === 'string') {
          // Ensure URL is complete
          if (!variantImageUrl.startsWith('http')) {
            variantImageUrl = 'https:' + variantImageUrl;
          }
          
          // Remove any existing query parameters to get base URL
          const baseImageUrl = variantImageUrl.split('?')[0].split('#')[0];
          
          // Build srcset with proper width parameters
          const imageSrcset = `${baseImageUrl}?width=165 165w, ${baseImageUrl}?width=360 360w, ${baseImageUrl}?width=533 533w, ${baseImageUrl}?width=720 720w, ${baseImageUrl}?width=940 940w, ${baseImageUrl}?width=1066 1066w`;
          
          // Update main image attributes
          // First, clear the src to force reload
          mainImage.src = '';
          mainImage.srcset = '';
          
          // Then set the new image
          mainImage.src = `${baseImageUrl}?width=533`;
          mainImage.srcset = imageSrcset;
          mainImage.setAttribute('src', `${baseImageUrl}?width=533`);
          mainImage.setAttribute('srcset', imageSrcset);
          mainImage.setAttribute('alt', productData.title);
          
          // Force image reload
          if (mainImage instanceof HTMLImageElement && mainImage.load) {
            mainImage.load();
          }
          
          // Update secondary/hover image if it exists
          if (secondaryImage && secondaryImage.tagName === 'IMG') {
            // Get the second image from the product's media array
            let secondImageUrl = null;
            if (productData.images && productData.images.length > 1) {
              // Try to find the second image associated with this variant
              // First, try to get image at index 1 (second image)
              const secondImage = productData.images[1];
              if (secondImage) {
                secondImageUrl = secondImage.src || secondImage.url || (typeof secondImage === 'string' ? secondImage : null);
              }
            }
            
            if (secondImageUrl && typeof secondImageUrl === 'string') {
              // Ensure URL is complete
              if (!secondImageUrl.startsWith('http')) {
                secondImageUrl = 'https:' + secondImageUrl;
              }
              
              // Remove any existing query parameters
              const baseSecondImageUrl = secondImageUrl.split('?')[0].split('#')[0];
              
              // Build srcset for secondary image
              const secondImageSrcset = `${baseSecondImageUrl}?width=165 165w, ${baseSecondImageUrl}?width=360 360w, ${baseSecondImageUrl}?width=533 533w, ${baseSecondImageUrl}?width=720 720w, ${baseSecondImageUrl}?width=940 940w, ${baseSecondImageUrl}?width=1066 1066w`;
              
              // Update secondary image
              secondaryImage.src = `${baseSecondImageUrl}?width=533`;
              secondaryImage.srcset = secondImageSrcset;
              secondaryImage.setAttribute('src', `${baseSecondImageUrl}?width=533`);
              secondaryImage.setAttribute('srcset', secondImageSrcset);
            } else {
              // If no second image available, remove the secondary image
              secondaryImage.remove();
            }
          }
        } else {
          console.warn('Could not extract valid image URL from variant:', variant);
        }
      } else if (!mainImage) {
        console.warn('Main image element not found in media container');
      }

      // Update quick add form variant ID
      const quickAddForm = this.querySelector('form');
      if (quickAddForm) {
        const variantInput = quickAddForm.querySelector('input[name="id"]');
        if (variantInput) {
          variantInput.value = variantId;
        }
      }

      // Update quick add button data attributes
      const quickAddButton = this.querySelector('.quick-add-icon__button');
      if (quickAddButton) {
        quickAddButton.setAttribute('data-product-url', productUrl);
        const quickAddIcon = quickAddButton.closest('.quick-add-icon');
        const quickAddModal = quickAddIcon?.nextElementSibling;
        
        if (quickAddModal && quickAddModal.tagName === 'QUICK-ADD-MODAL') {
          const newModalId = `QuickAdd-${productData.id}`;
          quickAddModal.id = newModalId;
          quickAddButton.setAttribute('data-modal', `#${newModalId}`);
          
          // Update onclick handler to use new modal ID
          const newOnclick = `event.preventDefault(); event.stopPropagation(); const modal = document.querySelector('#${newModalId}'); if(modal && typeof modal.show === 'function') { modal.show(this); } else { console.error('Modal not found or show method not available'); }`;
          quickAddButton.setAttribute('onclick', newOnclick);
        }
      }

      // Update selected state on swatches
      this.variantListItems.forEach(item => item.classList.remove('card__variant-list-item--selected'));
      clickedItem.classList.add('card__variant-list-item--selected');

    } catch (error) {
      console.error('Error updating product card:', error);
    } finally {
      // Remove loading state
      this.classList.remove('is-loading');
      
      // Show add-to-cart button again
      setTimeout(() => {
        addToCartButtons.forEach(button => {
          button.style.display = '';
        });
      }, 500);
    }
  }

  cleanImageSrc(src) {
    const { host, pathname } = new URL(src)
    return `//${host}${pathname}`
  }
}

customElements.define('product-card', ProductCard);
